import { mappers } from './utils';
import { ICheckServiceParams, TCheckServiceResult } from './types';
import { fetchCheckService } from '../../repositories/billing-tariffs/v3/check-service';
import { ECheckServiceErrorCode } from '../../redux/reducers';
import { THeaders } from '../../types/request';

export async function checkService(params: ICheckServiceParams): Promise<TCheckServiceResult> {
  const { httpApi, logger, telemetryService, parameters } = params;

  const requestConfig = {
    headers: [['Content-Type', 'application/json']] as THeaders,
  };

  try {
    const response = await fetchCheckService({
      httpApi,
      parameters,
      config: { requestConfig },
      mappers,
    });

    telemetryService.increment('check-service-request.success');

    return response as TCheckServiceResult;
  } catch (error) {
    logger.error(error, {
      description: 'Запрос /check-service на ФП',
      degradation: 'Пользователь не сможет разместить объявление',
    });

    telemetryService.increment('check-service-request.fail');

    return {
      success: false,
      payload: ECheckServiceErrorCode.fatalError,
    };
  }
}
